<template>
  <textarea
    v-model="text"
    class="vb-text-editor"
    :class="{
      'has-bottom-border': bottomBorder,
      seamless: seamless,
      'is-bordered': isBordered,
    }"
  >
  </textarea>
</template>

<script>
import AutoList from '3rd/autolist'
import MediumEditor from 'medium-editor'
import jQuery from 'jquery'
import $ from 'jquery'
import { trimHtml } from '@/utils'

window.MediumEditor = MediumEditor
window.jQuery = jQuery

const IMG_EDITOR_CLASS = 'img-editor'
const IMG_EDITOR_SELECTOR = '.img-editor'

const DEFAULT_TOOLS = [
  'bold',
  'italic',
  'underline',
  'anchor',
  'h2',
  'orderedlist',
  'unorderedlist',
  'quote',
]

export default {
  props: {
    text: { type: String, default: '' },
    placeholder: { type: String, default: 'Type your text' },
    bottomBorder: { type: Boolean, default: false },
    seamless: { type: Boolean, default: false },
    tools: { type: Array, default: () => DEFAULT_TOOLS },
    isBordered: { type: Boolean, default: false },
  },
  data() {
    return {
      focused: false,
      draggedElement: null,
    }
  },
  mounted() {
    this.editor = new MediumEditor(this.$el, {
      autoLink: true,
      toolbar: {
        buttons: this.tools,
      },
      extensions: {
        autolist: new AutoList(),
      },
      placeholder: {
        text: this.placeholder,
        hideOnClick: false,
      },
    })
    this.editor.setContent(this.text)
    this.editor.subscribe('editableInput', this.onEditableInput)
    this.editor.subscribe('blur', this.onBlur)
    this.editor.subscribe('focus', this.onFocus)

    this.editor.subscribe('editableDrag', this.drag)
    this.editor.subscribe('editableDrop', this.drop)

    const $editor = this.editor.elements[0]
    $($editor).on('mouseover', this.onMouseover)
    $($editor).on('mouseout', this.onMouseout)
  },
  beforeUpdate() {
    this.editor.setContent(this.text)
  },
  beforeDestroy() {
    const $editor = this.editor.elements[0]
    $($editor).off('mouseover', this.onMouseover)
    $($editor).off('mouseout', this.onMouseout)

    this.editor.unsubscribe('editableInput', this.onEditableInput)
    this.editor.unsubscribe('blur', this.onBlur)
    this.editor.unsubscribe('focus', this.onFocus)
    this.editor.unsubscribe('editableDrag', this.drag)
    this.editor.unsubscribe('editableDrop', this.drop)
    this.editor.destroy()
  },
  methods: {
    onEditableInput(event, editable) {
      this.$emit('content-changed', this.getContent())
    },
    onFocus(event, editable) {
      this.focused = true
      this.$emit('focus')
    },
    onBlur(event, editable) {
      this.$emit('blur', this.getTrimmedContent())
      this.focused = false
    },
    save() {
      this.$emit('save', this.getContent())
    },
    setContent(text) {
      this.editor.setContent(text)
    },
    getContent() {
      const content = this.editor.getContent(0) || ''
      // console.log(" == CONTENT ==")
      // console.log(content)
      // console.log(" == END CONTENT ==")
      return content
    },
    getTrimmedContent() {
      const content = this.getContent()
      const trimmedContent = trimHtml(content)
      return trimmedContent
    },
    drag(event) {
      if (!this.draggedElement) {
        this.draggedElement = event.target
      }
    },
    drop(event) {
      // do not allow to drop image onto whole editor (image would behave strangely)
      const targetClasses = new Set(event.target.classList)
      if (!targetClasses.has('vb-text-editor')) {
        event.target.before(this.draggedElement)
      }
      this.draggedElement = null
    },

    // image manipulations
    onMouseover(event) {
      const el = event.target
      if (el.tagName === 'IMG') {
        this.enableImageEditor(el)
      }
    },
    onMouseout(event) {
      const el = event.target
      const isImageEditor = el.classList.contains(IMG_EDITOR_CLASS)
      const isWithinImageEditor = $(el).parents(IMG_EDITOR_SELECTOR).length > 0
      if (!isWithinImageEditor) {
        this.clearImageEditors()
      }
    },
    enableImageEditor(img) {
      jQuery(img).wrap(`<div class="${IMG_EDITOR_CLASS}"></div>`)
      const editor = jQuery(img).parent()
      editor.append(`
        <div class="actions">
          <i class="ion ion-close remove-img"></i>
        </div>
      `)
      this.img = img
      jQuery('.remove-img', editor).on('click', onRemoveClick)

      function onRemoveClick() {
        jQuery('.remove-img', editor).off('click', onRemoveClick)
        editor.remove()
      }
    },
    async clearImageEditors() {
      const self = this
      const $editor = await this.getEditorRootElement()
      const editors = $(`${IMG_EDITOR_SELECTOR}`, $editor)
      editors.each((i, el) => {
        const img = $('img', el)
        $(el).replaceWith(img)
      })
    },
    getEditorRootElement() {
      return this.editor.elements[0]
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';

.vb-text-editor {
  outline: none;
  word-break: break-word;
  img {
    display: block;
    margin: 10px auto 20px;
    padding: 0 2px;
    border: 1px solid white;
  }

  .img-editor {
    position: relative;

    .actions {
      background: $black;
      position: absolute;
      top: 1px;
      right: 3px;

      .remove-img {
        padding: 5px;
        cursor: pointer;
        color: $white;
        &:hover {
          color: $silver;
        }
      }
    }
  }

  &.is-bordered {
    border: 1px solid #dcdfe6;
    padding: 5px 15px;
  }

  &.has-bottom-border {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid $grey150;
    transition: border-color 0.3s ease;
    width: 100%;
    outline: none;
    background-color: transparent;

    &:focus {
      border: none;
      border-bottom: 1px solid $brand-primary;
      box-shadow: none;

      &.is-bordered {
        border: 1px solid $yellow;
      }
    }
  }

  &.seamless {
    p {
      margin: 0 0 10px;
    }

    li {
      margin: 6px 0;
    }
  }
}
</style>
